import "../styles/PlayerCards.css"
import appIcon from "../images/app_icon.jpg"
import { StatementItem } from "./items/StatementItem"

export const Statement = ({ statement, size }) => {
    console.log({statement});
    return (<div className={`player-holdings-container-${size}`}>
        <div style={{ display: "flex" }}>
            <img src={appIcon} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
            <div className={`player-cards-header`}>
                Your Statement
            </div>
        </div>
        {statement.map((data, index) => {
            return <StatementItem key={`player_result_${index}`} size={size} data={data} />
        })}
    </div>)
}